import { render, staticRenderFns } from "./newstab.vue?vue&type=template&id=64d77d6c&"
import script from "./newstab.vue?vue&type=script&lang=js&"
export * from "./newstab.vue?vue&type=script&lang=js&"
import style0 from "./newstab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports